import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  Button,
  Flex,
  Text,
  Spacer,
} from "@chakra-ui/react";
import { LuInfo, LuLayers, LuLink2, LuArrowLeft, LuPackage, LuText } from "react-icons/lu";
import { useHistory, useLocation } from "react-router-dom";
import InfoTab from "./InventoryTabs/InfoTab/InfoTab";
import VariantTab from "./InventoryTabs/VariantTab/VariantTab";
import RelatedTab from "./InventoryTabs/RelatedTab/RelatedTab";
import ProjectTab from "./InventoryTabs/ProjectTab/ProjectTab";
import TitleBlockTab from "./InventoryTabs/TitleBlock/TitleBlockTab";

const InventoryTabs = () => {
  const history = useHistory();
  const location = useLocation();
  // Get product data passed from ProductTable
  const { title, category, title_block } = location?.state || {};

  
  const handleGoBack = () => history.goBack();

  return (
    <Box p={6} bg="gray.50" minH="100vh">
      {/* Top bar: Back button + Product info */}
      <Flex
        mb={4}
        align="center"
        justify="space-between"
        bg="white"
        px={5}
        py={3}
        borderRadius="lg"
        border="1px solid"
        borderColor="gray.200"
        shadow="sm"
      >
        {/* Left: Product Info */}
        <Flex align="flex-start" gap={3}>
          {title && category && (
            <Box>
              {/* Title */}
              <Text fontSize="20px" fontWeight="600" color="#172B4D">
                {title.charAt(0).toUpperCase() + title.slice(1)}
              </Text>

              {/* Category (under title, smaller text) */}
              <Text fontSize="14px" fontWeight="500" color="gray.500">
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </Text>
            </Box>
          )}
        </Flex>

        {/* Right: Back Button */}
        <Button
          leftIcon={<LuArrowLeft />}
          colorScheme="blue"
          size="sm"
          onClick={handleGoBack}
        >
          Back
        </Button>
      </Flex>

      {/* Tabs */}
      <Box bg="white" borderRadius="lg" border="1px solid" borderColor="gray.200" shadow="sm">
        <Tabs variant="line" colorScheme="blue">
          <TabList px={4} borderBottomColor="gray.200">
            <Tab fontWeight="500" fontSize="sm" py={4}>
              <LuInfo style={{ marginRight: "6px" }} />
              Info
            </Tab>
            <Tab fontWeight="500" fontSize="sm" py={4}>
              <LuLayers style={{ marginRight: "6px" }} />
              Variant
            </Tab>
            <Tab fontWeight="500" fontSize="sm" py={4}>
              <LuLink2 style={{ marginRight: "6px" }} />
              Related
            </Tab>
            <Tab fontWeight="500" fontSize="sm" py={4}>
              <LuPackage style={{ marginRight: "6px" }} />
              Projects
            </Tab>
            <Tab fontWeight="500" fontSize="sm" py={4}>
              <LuText style={{ marginRight: "6px" }} />
              Title Block
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={6}>
              <InfoTab />
            </TabPanel>
            <TabPanel p={0}>
              <VariantTab />
            </TabPanel>
            <TabPanel p={6}>
              <RelatedTab />
            </TabPanel>
            <TabPanel p={6}>
              <ProjectTab />
            </TabPanel>
            <TabPanel p={6}>
              <TitleBlockTab title_block={title_block}/>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default InventoryTabs;
